import { render } from "./portfolioUsers.vue?vue&type=template&id=558f1862"
import script from "./portfolioUsers.vue?vue&type=script&lang=ts"
export * from "./portfolioUsers.vue?vue&type=script&lang=ts"
script.render = render

export default script